/**
 * Global namespace for most components `parent` option.
 */
const dataBsParent = "data-bs-parent";
export default dataBsParent;
